import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

interface UpdateFlashcardStudySession {
  sessionId: string
  activityId: string
  confidence?: number
  elapsedTimeInSeconds?: number
}

export default function useUpdateFlashcardStudySession() {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: ({ sessionId, activityId, ...data }: UpdateFlashcardStudySession) => {
      return api.odin.activities.flashcards.studySession.update(activityId, sessionId, data)
    },
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: ["planner-get-weekly-objectives", "study-get-activities"],
      })
    },
  })

  return mutation
}
